import { createContext } from "react";
import type { ServerErrorContextValue } from "./ServerErrorContext.types";

export const ServerErrorContext = createContext<ServerErrorContextValue | undefined>(undefined);